<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-page-heading *ngIf="!!page.page_heading" [ttModel]="page.page_heading"></tt-page-heading>

        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-page-heading *ngIf="!!page.page_heading" [ttModel]="page.page_heading"></tt-page-heading>

        <tt-divider ttRememberId="orderheadcapjob_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="deliverydate_wish" [ttModel]="page.deliverydate_wish" ttReadonly></tt-input>
        <tt-date ttLabel="lastdt_production_finish" [(ttModel)]="page.lastdt_production_finish"></tt-date>
        <tt-button-goto [ttText]="'orderheadcapjob_captasksview'" [ttGoto]="'captasksview'" [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: page.order_internal_no }"></tt-button-goto>
        <tt-button-save ttText="orderheadcapjob_add_production" (ttClick)="addToBackwardPlanning()" [ttLoading]="addingToBackwardPlanning"></tt-button-save>
        <tt-button-save ttText="orderheadcapjob_add_production_forward" (ttClick)="addToForwardPlanning()" [ttLoading]="addingToForwardPlanning"></tt-button-save>
    </ng-container>
</ng-template>
